export function getLocalStorage(key: string): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.warn(`Failed to get localStorage key "${key}":`, error);
    return null;
  }
}

export function setLocalStorage(key: string, value: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn(`Failed to set localStorage key "${key}":`, error);
    return false;
  }
}

export function removeLocalStorage(key: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.warn(`Failed to remove localStorage key "${key}":`, error);
    return false;
  }
}

export function getLocalStorageJSON<T>(key: string): T | null {
  const value = getLocalStorage(key);
  if (!value) return null;

  try {
    return JSON.parse(value) as T;
  } catch (error) {
    console.warn(`Failed to parse JSON from localStorage key "${key}":`, error);
    return null;
  }
}

export function setLocalStorageJSON<T>(key: string, value: T): boolean {
  try {
    const jsonString = JSON.stringify(value);
    return setLocalStorage(key, jsonString);
  } catch (error) {
    console.warn(
      `Failed to stringify JSON for localStorage key "${key}":`,
      error
    );
    return false;
  }
}

export function getSessionStorage(key: string): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    console.warn(`Failed to get sessionStorage key "${key}":`, error);
    return null;
  }
}

export function setSessionStorage(key: string, value: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn(`Failed to set sessionStorage key "${key}":`, error);
    return false;
  }
}

export function removeSessionStorage(key: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    sessionStorage.removeItem(key);
    return true;
  } catch (error) {
    console.warn(`Failed to remove sessionStorage key "${key}":`, error);
    return false;
  }
}

export function isLocalStorageAvailable(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const testKey = "__localStorage_test__";
    localStorage.setItem(testKey, "test");
    localStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

export function isSessionStorageAvailable(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const testKey = "__sessionStorage_test__";
    sessionStorage.setItem(testKey, "test");
    sessionStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}
